<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <LoadingComponent :loading="loading" :message="loadingMessage" style="z-index: 1000;"></LoadingComponent>

    <merus-data-table :headers="headers" :items="respostas" :loading="loadingtable" :default-multi-sort="defaultSort"
      :loading-text="$t('system.messages.loading')">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('equipmentChecklist.populateTitle')" :token="token" :items="respostas"
          :csv-title="$t('equipmentChecklist.populateTitle')" :pdf-title="$t('equipmentChecklist.populateTitle')" :pdf-headers="headers"
          :pdf-filename="$t('equipmentChecklist.populateTitle')" hide-search>
          <template v-slot:add>
            <v-dialog v-model="dialog" fullscreen max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-toolbar dark color="primary">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ $t('equipmentChecklist.fillChecklist') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <!-- Step 1: Select Checklist -->
                      <v-card style="margin-bottom: 15px;">
                        <v-card-title style="color: #4a4a4a;">{{ $t('equipmentChecklist.selectChecklist') }}</v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" sm="12" md="6">
                              <v-autocomplete
                                v-model="editedItem.id_checklist_equipamento"
                                :items="checklistsDisponiveis"
                                item-text="nome_checklist"
                                item-value="id_checklist_equipamento"
                                outlined
                                :label="$t('equipmentChecklist.checklist') + ' *'"
                                :rules="[validaCampo]"
                                @change="onChecklistSelected"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>

                      <!-- Step 2: Select Equipment -->
                      <v-card style="margin-bottom: 15px;" v-if="editedItem.id_checklist_equipamento">
                        <v-card-title style="color: #4a4a4a;">{{ $t('equipmentChecklist.selectEquipment') }}</v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" sm="12" md="6">
                              <v-autocomplete
                                v-model="editedItem.id_equipamentos"
                                :items="equipamentosFiltrados"
                                item-text="displayText"
                                item-value="id_equipamento"
                                outlined multiple chips
                                :label="$t('equipmentChecklist.equipment') + ' *'"
                                :rules="[validaCampo]"
                              >
                                <template v-slot:append-outer>
                                  <v-btn
                                    icon
                                    color="primary"
                                    @click="openQrScanner"
                                    :disabled="!editedItem.id_checklist_equipamento"
                                    title="Escanear QR Code"
                                  >
                                    <v-icon>mdi-qrcode-scan</v-icon>
                                  </v-btn>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                              <v-text-field
                                :value="user.nome_usuario"
                                outlined
                                :label="$t('equipmentChecklist.responsibleEmployee')"
                                readonly
                                :disabled="true"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                              <v-datetime-picker
                                :label="$t('equipmentChecklist.realizationDateTime')"
                                v-model="editedItem.dt_realizacao"
                                :time-picker-props="timeProps"
                                :text-field-props="textFieldProps"
                                time-format="HH:mm:ss"
                                date-format="dd/MM/yyyy"
                                :clear-text="$t('datetime.close')"
                              >
                                <template slot="dateIcon">
                                  <v-icon>mdi-calendar</v-icon>
                                </template>
                                <template slot="timeIcon">
                                  <v-icon>mdi-clock</v-icon>
                                </template>
                              </v-datetime-picker>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>

                      <!-- Step 3: Fill Fields -->
                      <v-card style="margin-bottom: 15px;" v-if="editedItem.id_checklist_equipamento && checklistSelecionado">
                        <v-card-title style="color: #4a4a4a;">{{ $t('equipmentChecklist.fillFields') }}</v-card-title>
                        <v-card-text>
                          <v-row v-for="campo in checklistSelecionado.campos" :key="campo.id_campo" style="margin-bottom: 10px;">
                            <v-col cols="12" sm="12" md="12">
                              <!-- Text Field -->
                              <v-text-field
                                v-if="campo.tipo === 'Text'"
                                v-model="valoresCampos[campo.id_campo]"
                                :label="campo.label + (campo.obrigatorio ? ' *' : '')"
                                outlined
                                :rules="campo.obrigatorio ? [validaCampo] : []"
                              ></v-text-field>
                              
                              <!-- Number Field -->
                              <v-text-field
                                v-else-if="campo.tipo === 'Number'"
                                v-model.number="valoresCampos[campo.id_campo]"
                                :label="campo.label + (campo.obrigatorio ? ' *' : '')"
                                outlined
                                type="number"
                                :rules="campo.obrigatorio ? [validaCampo] : []"
                              ></v-text-field>
                              
                              <!-- Date Field -->
                              <v-menu
                                v-else-if="campo.tipo === 'Date'"
                                v-model="menuDate[campo.id_campo]"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="valoresCampos[campo.id_campo]"
                                    :label="campo.label + (campo.obrigatorio ? ' *' : '')"
                                    outlined
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules="campo.obrigatorio ? [validaCampo] : []"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="valoresCampos[campo.id_campo]"
                                  @input="menuDate[campo.id_campo] = false"
                                  locale="pt-BR"
                                ></v-date-picker>
                              </v-menu>
                              
                              <!-- Select Field -->
                              <v-select
                                v-else-if="campo.tipo === 'Select'"
                                v-model="valoresCampos[campo.id_campo]"
                                :items="campo.opcoes || []"
                                :label="campo.label + (campo.obrigatorio ? ' *' : '')"
                                outlined
                                :rules="campo.obrigatorio ? [validaCampo] : []"
                              ></v-select>
                              
                              <!-- Checkbox Field -->
                              <v-checkbox
                                v-else-if="campo.tipo === 'Checkbox'"
                                v-model="valoresCampos[campo.id_campo]"
                                :label="campo.label + (campo.obrigatorio ? ' *' : '')"
                                :rules="campo.obrigatorio ? [validaCampoCheckbox] : []"
                              ></v-checkbox>
                              
                              <!-- Textarea Field -->
                              <v-textarea
                                v-else-if="campo.tipo === 'Textarea'"
                                v-model="valoresCampos[campo.id_campo]"
                                :label="campo.label + (campo.obrigatorio ? ' *' : '')"
                                outlined
                                rows="3"
                                :rules="campo.obrigatorio ? [validaCampo] : []"
                              ></v-textarea>
                              
                              <!-- Photo Field -->
                              <div v-else-if="campo.tipo === 'Photo'">
                                <v-file-input
                                  v-model="photoFiles[campo.id_campo]"
                                  :label="campo.label + (campo.obrigatorio ? ' *' : '')"
                                  outlined
                                  accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                                  prepend-icon="mdi-camera"
                                  :rules="campo.obrigatorio ? [validaCampoPhoto, validaCampoPhotoType] : [validaCampoPhotoType]"
                                  @change="onPhotoChange($event, campo.id_campo)"
                                  show-size
                                  :max-size="5242880"
                                ></v-file-input>
                                <v-img
                                  v-if="photoPreviews[campo.id_campo]"
                                  :src="photoPreviews[campo.id_campo]"
                                  max-height="200"
                                  max-width="300"
                                  contain
                                  class="mt-2"
                                ></v-img>
                              </div>
                            </v-col>
                          </v-row>
                          <v-alert v-if="!checklistSelecionado || !checklistSelecionado.campos || checklistSelecionado.campos.length === 0" type="info" outlined>
                            {{ $t('equipmentChecklist.noFields') }}
                          </v-alert>
                        </v-card-text>
                      </v-card>

                      <!-- Observations -->
                      <v-card style="margin-bottom: 15px;" v-if="editedItem.id_checklist_equipamento">
                        <v-card-title style="color: #4a4a4a;">{{ $t('equipmentChecklist.observations') }}</v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                v-model="editedItem.observacoes"
                                outlined
                                rows="3"
                                :label="$t('equipmentChecklist.observations')"
                                counter
                                maxlength="1000"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="blue" @click="viewItem(item)">mdi-eye</v-icon>
      </template>
      <template v-slot:item.dt_inclusao_extenso="{ item }">
        {{ item.dt_inclusao_extenso || '-' }}
      </template>
    </merus-data-table>

    <!-- QR Scanner Dialog -->
    <v-dialog v-model="qrScannerDialog" fullscreen max-width="100%">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="stopQrScanner">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('equipmentChecklist.scanQrCode') || 'Escanear QR Code do Equipamento' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="stopQrScanner">{{ $t('button.close') || 'Fechar' }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row justify="center" align="center">
              <v-col cols="12" sm="10" md="8">
                <v-alert
                  v-if="qrScannerError"
                  type="error"
                  dismissible
                  @input="qrScannerError = null"
                  class="mb-4"
                >
                  {{ qrScannerError }}
                </v-alert>
                <qrcode-stream
                  v-if="qrScannerDialog"
                  @decode="onDecode"
                  @init="onInit"
                  :camera="camera"
                  class="qr-scanner"
                ></qrcode-stream>
                <v-alert
                  v-if="!qrScannerError && qrScannerDialog"
                  type="info"
                  class="mt-4"
                >
                  {{ $t('equipmentChecklist.qrScannerInstructions') || 'Posicione o QR Code do equipamento na frente da câmera' }}
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- View Dialog -->
    <v-dialog v-model="viewDialog" max-width="800px" scrollable>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="viewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('equipmentChecklist.viewChecklist') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text style="margin-top: 15px;" v-if="respostaVisualizada">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <strong>{{ $t('equipmentChecklist.checklist') }}:</strong> {{ respostaVisualizada.nome_checklist }}
              </v-col>
              <v-col cols="12" sm="6">
                <strong>{{ $t('equipmentChecklist.equipment') }}:</strong>
                <div v-if="respostaVisualizada.equipamentos && respostaVisualizada.equipamentos.length > 0">
                  <v-chip
                    v-for="(equip, index) in respostaVisualizada.equipamentos"
                    :key="index"
                    small
                    class="ma-1"
                    color="primary"
                  >
                    {{ equip.nome_equipamento || equip.cod_equipamento }} ({{ equip.cod_equipamento }})
                  </v-chip>
                </div>
                <span v-else>
                  {{ respostaVisualizada.nome_equipamento || 'N/A' }} 
                  <span v-if="respostaVisualizada.cod_equipamento">({{ respostaVisualizada.cod_equipamento }})</span>
                </span>
              </v-col>
              <v-col cols="12" sm="6" v-if="respostaVisualizada.nome_funcionario">
                <strong>{{ $t('equipmentChecklist.responsibleEmployee') }}:</strong> {{ respostaVisualizada.nome_funcionario }} ({{ respostaVisualizada.matricula_funcionario }})
              </v-col>
              <v-col cols="12" sm="6">
                <strong>{{ $t('equipmentChecklist.createdAt') }}:</strong> {{ respostaVisualizada.dt_inclusao_extenso }}
              </v-col>
              <v-col cols="12" sm="6" v-if="respostaVisualizada.dt_realizacao_extenso">
                <strong>{{ $t('equipmentChecklist.realizationDateTime') }}:</strong> {{ respostaVisualizada.dt_realizacao_extenso }}
              </v-col>
              <v-col cols="12" v-if="respostaVisualizada.observacoes">
                <strong>{{ $t('equipmentChecklist.observations') }}:</strong> {{ respostaVisualizada.observacoes }}
              </v-col>
            </v-row>
            <v-divider style="margin: 15px 0;"></v-divider>
            <v-row v-for="valor in respostaVisualizada.valores" :key="valor.id_valor">
              <v-col cols="12">
                <strong>{{ valor.label }}:</strong>
                <span v-if="valor.tipo === 'Checkbox'">
                  {{ valor.valor === 'true' || valor.valor === true ? $t('system.yes') : $t('system.no') }}
                </span>
                <div v-else-if="valor.tipo === 'Photo' && valor.valor">
                  <v-img
                    :src="getImageUrl(valor.valor)"
                    max-height="400"
                    max-width="600"
                    contain
                    class="mt-2"
                    @error="handleImageError"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>
                <span v-else>{{ valor.valor || '-' }}</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import { ApiBaseUrl } from "@/constants";
import LoadingComponent from '../LoadingComponent.vue';
import MerusDataTable from "../Tables/MerusDataTable.vue";
import CadastroToolbar from "../Toolbars/CadastroToolbar.vue";
import EventBus from "@/utils/eventBus";
import { QrcodeStream } from 'vue-qrcode-reader';

export default {
  components: {
    LoadingComponent,
    MerusDataTable,
    CadastroToolbar,
    QrcodeStream
  },
  data: () => ({
    user: null,
    token: null,
    loading: false,
    loadingMessage: "",
    loadingtable: true,
    formValidado: false,
    dialog: false,
    viewDialog: false,
    respostas: [],
    checklistsDisponiveis: [],
    equipamentos: [],
    kits: [],
    funcionarios: [],
    checklistSelecionado: null,
    respostaVisualizada: null,
    editedItem: {
      id_checklist_equipamento: null,
      id_equipamentos: [],
      id_funcionario_responsavel: null,
      observacoes: null,
      dt_realizacao: null
    },
    valoresCampos: {},
    menuDate: {},
    photoFiles: {},
    photoPreviews: {},
    defaultItem: {
      id_checklist_equipamento: null,
      id_equipamentos: [],
      id_funcionario_responsavel: null,
      observacoes: null,
      dt_realizacao: null
    },
    qrScannerDialog: false,
    scanning: false,
    qrScannerError: null,
    camera: 'auto'
  }),
  computed: {
    defaultSort() {
      return [
        { value: 'dt_inclusao', options: { text: this.$t('routs.decreasing'), value: -1 } }];
    },
    headers() {
      return [
        { text: this.$t('equipmentChecklist.headers.id'), value: "id_resposta", align: " d-none" },
        { text: this.$t('equipmentChecklist.headers.checklist'), value: "nome_checklist", sortable: true, filtrable: true },
        { text: this.$t('equipmentChecklist.headers.equipment'), value: "nome_equipamento", sortable: true, filtrable: true },
        { text: this.$t('equipmentChecklist.headers.equipmentCode'), value: "cod_equipamento", sortable: true },
        { text: this.$t('equipmentChecklist.headers.kitCode'), value: "cod_kit", sortable: true },
        { text: this.$t('equipmentChecklist.headers.kitName'), value: "nome_kit", sortable: true },
        { text: this.$t('equipmentChecklist.headers.responsibleEmployee'), value: "nome_usuario", sortable: true },
        { text: this.$t('equipmentChecklist.headers.createdAt'), value: "dt_inclusao_extenso", sortable: true },
        { text: this.$t('equipmentChecklist.headers.actions'), value: "actions", sortable: false }]
    },
    equipamentosFiltrados() {
      if (!this.checklistSelecionado) {
        return [];
      }

      // Any profile can select any equipment or kit: show all active equipment and kits
      const equipamentosFiltrados = (this.equipamentos || [])
        .filter(e => e.ativo === 1)
        .map(e => ({
          ...e,
          id_equipamento: e.id_equipamento,
          nome_equipamento: e.nome_equipamento,
          cod_equipamento: e.cod_equipamento,
          tipo: 'equipamento',
          displayText: `${e.nome_equipamento} (${e.cod_equipamento || ''})`
        }));

      const kitsFormatados = (this.kits || [])
        .filter(k => k.ativo === 1)
        .map(k => ({
          ...k,
          id_equipamento: k.id_kit,
          nome_equipamento: k.nome_kit || k.cod_kit,
          cod_equipamento: k.cod_kit,
          id_tipo_kit: k.id_tipo_kit,
          tipo: 'kit',
          displayText: `[KIT] ${k.nome_kit || k.cod_kit} (${k.cod_kit})`
        }));

      return [...kitsFormatados, ...equipamentosFiltrados];
    },
    timeProps() {
      return {
        useSeconds: true,
      }
    },
    textFieldProps() {
      return {
        prependIcon: "mdi-calendar"
      }
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    qrScannerDialog(val) {
      if (!val) {
        this.stopQrScanner();
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  methods: {
    validaCampo(v) {
      return !!v || this.$t('validation.required');
    },
    validaCampoCheckbox(v) {
      return v !== undefined && v !== null || this.$t('validation.required');
    },
    validaCampoPhoto(v) {
      if (!v || (Array.isArray(v) && v.length === 0)) {
        return this.$t('validation.required');
      }
      return true;
    },
    validaCampoPhotoType(v) {
      if (!v || (Array.isArray(v) && v.length === 0)) {
        return true; // Not required
      }
      const file = Array.isArray(v) ? v[0] : v;
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        return this.$t('equipmentChecklist.invalidImageType') || 'Invalid image type. Please select JPEG, PNG, GIF, or WebP.';
      }
      if (file.size > 5242880) {
        return this.$t('equipmentChecklist.imageTooLarge') || 'Image size must be less than 5MB.';
      }
      return true;
    },
    onPhotoChange(file, campoId) {
      if (!file || (Array.isArray(file) && file.length === 0)) {
        this.photoPreviews[campoId] = null;
        this.valoresCampos[campoId] = null;
        return;
      }
      const selectedFile = Array.isArray(file) ? file[0] : file;
      if (selectedFile) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.photoPreviews[campoId] = e.target.result;
        };
        reader.readAsDataURL(selectedFile);
        // Store file object temporarily, will be uploaded on save
        this.valoresCampos[campoId] = null; // Will be set to path after upload
      }
    },
    uploadPhoto(campoId) {
      return new Promise((resolve, reject) => {
        const file = this.photoFiles[campoId];
        if (!file || (Array.isArray(file) && file.length === 0)) {
          resolve(null);
          return;
        }
        const selectedFile = Array.isArray(file) ? file[0] : file;
        if (!selectedFile) {
          resolve(null);
          return;
        }
        // Generate unique filename
        const timestamp = Date.now();
        const filename = `checklist_${this.editedItem.id_checklist_equipamento}_campo_${campoId}_${timestamp}`;
        // Convert file to base64
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64Data = e.target.result;
          const uploadData = {
            file: base64Data,
            filename: filename,
            folder: 'checklists_equipamentos'
          };
          apiController.request(apiController.endpoints.uploadImg, {
            data: uploadData,
            silent: true,
            onSuccess: (response) => {
              if (response.data && !response.data.error && response.data.path) {
                // Store the full path as returned by API for consistency
                // The API returns: "static/uploads/checklists_equipamentos/filename.jpg"
                // We'll store it as-is and handle URL construction in getImageUrl
                const path = response.data.path;
                console.log('Photo uploaded, path:', path);
                resolve(path);
              } else {
                reject(new Error(response.data?.message || 'Upload failed'));
              }
            },
            onError: (error) => {
              reject(error);
            },
          });
        };
        reader.onerror = () => {
          reject(new Error('Failed to read file'));
        };
        reader.readAsDataURL(selectedFile);
      });
    },
    findFuncionarioByUserName() {
      if (!this.user || !this.user.nome_usuario || !this.funcionarios || this.funcionarios.length === 0) {
        return null;
      }
      
      const userName = this.user.nome_usuario.trim().toLowerCase();
      
      // Try to find a match by comparing user name with funcionario nome or nome_completo
      const funcionario = this.funcionarios.find(f => {
        if (!f) return false;
        
        // Check if nome matches (case-insensitive)
        if (f.nome && f.nome.trim().toLowerCase() === userName) {
          return true;
        }
        
        // Check if nome_completo matches (case-insensitive)
        if (f.nome_completo && f.nome_completo.trim().toLowerCase() === userName) {
          return true;
        }
        
        // Check if descricao contains the user name (descricao is "matricula nome")
        if (f.descricao) {
          const descricaoLower = f.descricao.trim().toLowerCase();
          // Extract just the name part (after matricula)
          const namePart = descricaoLower.split(' ').slice(1).join(' ');
          if (namePart === userName) {
            return true;
          }
        }
        
        return false;
      });
      
      return funcionario ? funcionario.id_funcionario : null;
    },
    initialize() {
      this.populaRespostas();
      this.populaChecklists();
      this.populaEquipamentos();
      this.populaKits();
      this.populaFuncionarios();
    },
    populaRespostas() {
      this.loadingtable = true;
      const today = new Date();
      const startDate = new Date(today.getFullYear() - 1, today.getMonth(), 1).toISOString().split('T')[0];
      const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];
      
      apiController.request(apiController.endpoints.getChecklistsequipamentorespostaspordata, {
        params: { dti: startDate, dtf: endDate },
        onSuccess: (response) => {
          // The API now returns equipment data when id_tipo_kit is null, and kit data when id_tipo_kit is not null
          // The SQL query handles the selection automatically based on id_tipo_kit
          this.respostas = response.data || [];
          this.loadingtable = false;
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    populaChecklists() {
      const today = new Date();
      const startDate = new Date(today.getFullYear() - 1, today.getMonth(), 1).toISOString().split('T')[0];
      const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];
      
      apiController.request(apiController.endpoints.getChecklistsequipamentospordata, {
        params: { dti: startDate, dtf: endDate },
        onSuccess: (response) => {
          this.checklistsDisponiveis = response.data || [];
        },
      });
    },
    populaEquipamentos() {
      apiController.request(apiController.endpoints.getallEquipamentos, {
        onSuccess: (response) => {
          this.equipamentos = response.data || [];
        },
      });
    },
    populaKits() {
      apiController.request(apiController.endpoints.getallKits, {
        onSuccess: (response) => {
          this.kits = response.data || [];
        },
      });
    },
    populaFuncionarios() {
      apiController.request(apiController.endpoints.getallFuncionarios, {
        onSuccess: (response) => {
          this.funcionarios = response.data || [];
        },
      });
    },
    onChecklistSelected() {
      if (this.editedItem.id_checklist_equipamento) {
        this.loading = true;
        this.loadingMessage = this.$t('system.messages.loading');
        apiController.request(apiController.endpoints.getChecklistequipamentoporid, {
          params: { id: this.editedItem.id_checklist_equipamento },
          onSuccess: (response) => {
            this.loading = false;
            // Handle response - check if it's an error response or valid data
            if (response.data) {
              // Check if response has erro property (API error response)
              if (response.data.erro === true) {
                EventBus.$emit('show-alert', {
                  mensagem: response.data.mensagem || this.$t('equipmentChecklist.loadError'),
                  tipo: 'error'
                });
                this.checklistSelecionado = null;
                return;
              }

              // Valid checklist data - set it regardless of id_tipo_kit value (null or not)
              this.checklistSelecionado = response.data;

              // Ensure campos is an array (handle case where it might be undefined)
              if (!this.checklistSelecionado.campos) {
                this.checklistSelecionado.campos = [];
              }

              // Initialize valoresCampos for all fields
              this.valoresCampos = {};
              this.photoFiles = {};
              this.photoPreviews = {};

              if (this.checklistSelecionado.campos && this.checklistSelecionado.campos.length > 0) {
                this.checklistSelecionado.campos.forEach(campo => {
                  this.valoresCampos[campo.id_campo] = campo.tipo === 'Checkbox' ? false : null;
                  this.menuDate[campo.id_campo] = false;
                  if (campo.tipo === 'Photo') {
                    this.photoFiles[campo.id_campo] = null;
                    this.photoPreviews[campo.id_campo] = null;
                  }
                });
              }

              // Ensure kits are loaded if checklist is for kit type
              if (this.checklistSelecionado.id_tipo_kit && this.kits.length === 0) {
                this.populaKits();
              }
            } else {
              // No data in response
              EventBus.$emit('show-alert', {
                mensagem: this.$t('equipmentChecklist.loadError'),
                tipo: 'error'
              });
              this.checklistSelecionado = null;
            }
          },
          onError: () => {
            this.loading = false;
          },
        });
      } else {
        this.checklistSelecionado = null;
        this.valoresCampos = {};
        this.photoFiles = {};
        this.photoPreviews = {};
      }
    },
    viewItem(item) {
      this.loading = true;
      this.loadingMessage = this.$t('system.messages.loading');
      apiController.request(apiController.endpoints.getChecklistequipamentorespostaporid, {
        params: { id: item.id_resposta },
        onSuccess: (response) => {
          this.loading = false;
          // Handle response - check if it's an error response or valid data
          if (response.data) {
            // Check if response has erro property (API error response)
            if (response.data.erro === true) {
              EventBus.$emit('show-alert', {
                mensagem: response.data.mensagem || this.$t('equipmentChecklist.loadError'),
                tipo: 'error'
              });
              this.respostaVisualizada = null;
              return;
            }

            // Valid resposta data - set it regardless of whether it's for equipment or kits
            this.respostaVisualizada = response.data;

            // Ensure valores is an array (handle case where it might be undefined)
            if (!this.respostaVisualizada.valores) {
              this.respostaVisualizada.valores = [];
            }

            // Ensure equipamentos is an array (handle backward compatibility)
            if (!this.respostaVisualizada.equipamentos) {
              // If equipamentos array doesn't exist but nome_equipamento does, create array for backward compatibility
              if (this.respostaVisualizada.nome_equipamento || this.respostaVisualizada.cod_equipamento) {
                this.respostaVisualizada.equipamentos = [{
                  nome_equipamento: this.respostaVisualizada.nome_equipamento,
                  cod_equipamento: this.respostaVisualizada.cod_equipamento,
                  nome_kit: this.respostaVisualizada.nome_kit,
                  cod_kit: this.respostaVisualizada.cod_kit
                }];
              } else {
                this.respostaVisualizada.equipamentos = [];
              }
            }

            this.viewDialog = true;
          } else {
            // No data in response
            EventBus.$emit('show-alert', {
              mensagem: this.$t('equipmentChecklist.loadError'),
              tipo: 'error'
            });
            this.respostaVisualizada = null;
          }
        },
        onError: () => {
          this.loading = false;
          this.respostaVisualizada = null;
        },
      });
    },
    getImageUrl(path) {
      if (!path) {
        return '';
      }
      // If path already starts with http or https, use it as is
      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
      }
      // The API returns: "static/uploads/checklists_equipamentos/filename.jpg"
      // express.static serves from /static root, so we need to remove "static/" prefix
      // Result: "/uploads/checklists_equipamentos/filename.jpg"
      let cleanPath = path;
      if (cleanPath.startsWith('static/uploads/')) {
        cleanPath = cleanPath.substring(7); // Remove "static/" -> "uploads/..."
      } else if (cleanPath.startsWith('static/')) {
        cleanPath = cleanPath.substring(7); // Remove "static/" -> "..."
      }
      // Ensure leading slash
      if (!cleanPath.startsWith('/')) {
        cleanPath = '/' + cleanPath;
      }
      return `${ApiBaseUrl}${cleanPath}`;
    },
    handleImageError(event) {
      // Replace broken image with placeholder text
      event.target.style.display = 'none';
      const placeholder = document.createElement('div');
      placeholder.textContent = this.$t('equipmentChecklist.imageLoadError') || 'Image not available';
      placeholder.className = 'text-center pa-4 grey lighten-2';
      event.target.parentNode.appendChild(placeholder);
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.checklistSelecionado = null;
        this.valoresCampos = {};
        this.menuDate = {};
        this.photoFiles = {};
        this.photoPreviews = {};
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    async save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        // Validate required fields
        if (!this.checklistSelecionado || !this.checklistSelecionado.campos) {
          EventBus.$emit('show-alert', {
            mensagem: this.$t('equipmentChecklist.loadError'),
            tipo: 'error'
          });
          return;
        }

        // Validate required Photo fields
        const camposObrigatorios = this.checklistSelecionado.campos.filter(c => c.obrigatorio);
        const camposInvalidos = camposObrigatorios.filter(c => {
          if (c.tipo === 'Photo') {
            const file = this.photoFiles[c.id_campo];
            return !file || (Array.isArray(file) && file.length === 0);
          } else {
            const valor = this.valoresCampos[c.id_campo];
            return valor === null || valor === undefined || valor === '';
          }
        });

        if (camposInvalidos.length > 0) {
          EventBus.$emit('show-alert', {
            mensagem: this.$t('equipmentChecklist.requiredFieldsMissing'),
            tipo: 'warning'
          });
          return;
        }

        this.loading = true;
        this.loadingMessage = this.$t('system.messages.uploadingPhotos') || 'Uploading photos...';

        // Upload all Photo fields first
        const photoUploadPromises = this.checklistSelecionado.campos
          .filter(campo => campo.tipo === 'Photo')
          .map(campo => {
            return this.uploadPhoto(campo.id_campo)
              .then(path => {
                if (path) {
                  this.valoresCampos[campo.id_campo] = path;
                }
                return { campoId: campo.id_campo, path };
              });
          });

        try {
          await Promise.all(photoUploadPromises);

          // Prepare valores array
          const valores = this.checklistSelecionado.campos.map(campo => {
            let valor = this.valoresCampos[campo.id_campo];
            // Convert to string for storage
            if (valor === null || valor === undefined) {
              valor = null;
            } else if (campo.tipo === 'Checkbox') {
              valor = valor ? 'true' : 'false';
            } else if (campo.tipo === 'Date' && valor) {
              // Date is already in YYYY-MM-DD format from date picker
              valor = String(valor);
            } else {
              valor = String(valor);
            }
            return {
              id_campo: campo.id_campo,
              valor: valor
            };
          });

          // Find funcionario ID by user name
          const funcionarioId = this.findFuncionarioByUserName();
          this.editedItem.id_funcionario_responsavel = funcionarioId;

          // Format datetime for API
          let dtRealizacao = null;
          if (this.editedItem.dt_realizacao) {
            if (typeof this.editedItem.dt_realizacao === 'string') {
              dtRealizacao = this.editedItem.dt_realizacao;
            } else {
              dtRealizacao = this.editedItem.dt_realizacao.toISOString();
            }
          }

          // Prepare equipment info for payload
          const equipamentosInfo = this.editedItem.id_equipamentos.map(idEquip => {
            const item = this.equipamentosFiltrados.find(
              item => item.id_equipamento === idEquip
            );
            return {
              id_equipamento: idEquip,
              tipo: item ? item.tipo : 'equipamento',
              id_tipo_kit: item && item.tipo === 'kit' ? (item.id_tipo_kit || 1) : null
            };
          });

          // Determine id_tipo_kit from first equipment (for backward compatibility)
          const firstEquipId = this.editedItem.id_equipamentos[0];
          const selectedItem = this.equipamentosFiltrados.find(
            item => item.id_equipamento === firstEquipId
          );
          const idTipoKit = selectedItem && selectedItem.tipo === 'kit'
            ? 1
            : null;

          const payload = {
            id_checklist_equipamento: this.editedItem.id_checklist_equipamento,
            id_equipamentos: this.editedItem.id_equipamentos,
            equipamentos_info: equipamentosInfo,
            id_tipo_kit: idTipoKit,
            id_funcionario_responsavel: this.editedItem.id_funcionario_responsavel || null,
            observacoes: this.editedItem.observacoes || null,
            dt_realizacao: dtRealizacao,
            valores: valores
          };

          this.loadingMessage = this.$t('system.messages.saving');

          const response = await apiController.request(apiController.endpoints.insertChecklistequipamentoresposta, { data: payload, silent: true });
          this.loading = false;
          if (response.data.erro) {
            EventBus.$emit('show-alert', {
              mensagem: this.$t('equipmentChecklist.saveError'),
              tipo: 'error'
            });
          } else {
            EventBus.$emit('show-alert', {
              mensagem: this.$t('equipmentChecklist.saveSuccess'),
              tipo: 'success'
            });
            this.close();
            this.populaRespostas();
          }
        } catch (e) {
          this.loading = false;
          if (e.response && e.response.data) {
            EventBus.$emit('show-error', { error: e });
          } else {
            EventBus.$emit('show-alert', {
              mensagem: this.$t('equipmentChecklist.photoUploadError') || 'Error uploading photos. Please try again.',
              tipo: 'error'
            });
          }
        }
      }
    },
    openQrScanner() {
      if (!this.editedItem.id_checklist_equipamento) {
        EventBus.$emit('show-alert', {
          mensagem: this.$t('equipmentChecklist.selectChecklistFirst') || 'Por favor, selecione um checklist primeiro',
          tipo: 'warning'
        });
        return;
      }
      this.qrScannerDialog = true;
      this.qrScannerError = null;
      this.scanning = false;
    },
    onDecode(decodedText) {
      try {
        // Parse JSON from QR code
        const qrData = JSON.parse(decodedText);
        
        // Check for equipment or kit data
        if (!qrData.id_equipamento && !qrData.cod_equipamento && !qrData.id_kit && !qrData.cod_kit) {
          throw new Error('QR Code inválido: dados do equipamento ou kit não encontrados');
        }

        // Find in filtered list (equipment or kit) by id first (most reliable)
        let itemEncontrado = null;
        
        // Try equipment id
        if (qrData.id_equipamento) {
          itemEncontrado = this.equipamentosFiltrados.find(
            e => e.id_equipamento === qrData.id_equipamento || 
                 e.id_equipamento === parseInt(qrData.id_equipamento)
          );
          // Add to equipment array if found
          if (itemEncontrado && this.editedItem.id_equipamentos) {
            const equipId = itemEncontrado.id_equipamento;
            if (!this.editedItem.id_equipamentos.includes(equipId)) {
              this.editedItem.id_equipamentos.push(equipId);
            }
          }
        }
        
        // Try kit id
        if (!itemEncontrado && qrData.id_kit) {
          itemEncontrado = this.equipamentosFiltrados.find(
            e => e.id_equipamento === qrData.id_kit || 
                 e.id_equipamento === parseInt(qrData.id_kit)
          );
        }
        
        // Fallback to cod_equipamento if not found by id
        if (!itemEncontrado && qrData.cod_equipamento) {
          itemEncontrado = this.equipamentosFiltrados.find(
            e => e.cod_equipamento === qrData.cod_equipamento
          );
        }
        
        // Fallback to cod_kit if not found
        if (!itemEncontrado && qrData.cod_kit) {
          itemEncontrado = this.equipamentosFiltrados.find(
            e => e.cod_equipamento === qrData.cod_kit
          );
        }

        if (!itemEncontrado) {
          // Try to find in all equipamentos and kits (not filtered) to give better error message
          let itemGeral = null;
          
          // Try equipment first
          if (qrData.id_equipamento) {
            itemGeral = this.equipamentos.find(
              e => e.id_equipamento === qrData.id_equipamento || 
                   e.id_equipamento === parseInt(qrData.id_equipamento)
            );
          }
          if (!itemGeral && qrData.cod_equipamento) {
            itemGeral = this.equipamentos.find(
              e => e.cod_equipamento === qrData.cod_equipamento
            );
          }
          
          // Try kits
          if (!itemGeral && qrData.id_kit) {
            itemGeral = this.kits.find(
              k => k.id_kit === qrData.id_kit || 
                   k.id_kit === parseInt(qrData.id_kit)
            );
          }
          if (!itemGeral && qrData.cod_kit) {
            itemGeral = this.kits.find(
              k => k.cod_kit === qrData.cod_kit
            );
          }

          if (itemGeral) {
            EventBus.$emit('show-alert', {
              mensagem: this.$t('equipmentChecklist.equipmentNotAvailableForChecklist') || 
                       `Equipamento ou Kit encontrado, mas não está disponível para o tipo de checklist selecionado.`,
              tipo: 'warning'
            });
          } else {
            EventBus.$emit('show-alert', {
              mensagem: this.$t('equipmentChecklist.equipmentNotFound') || 
                       'Equipamento ou Kit não encontrado no sistema.',
              tipo: 'error'
            });
          }
          return;
        }

        // Set the equipment or kit
        // Add to equipment array if not already present
        if (!this.editedItem.id_equipamentos) {
          this.editedItem.id_equipamentos = [];
        }
        if (!this.editedItem.id_equipamentos.includes(itemEncontrado.id_equipamento)) {
          this.editedItem.id_equipamentos.push(itemEncontrado.id_equipamento);
        }
        
        // Stop scanning and close dialog
        this.stopQrScanner();
        
        // Show success message
        const itemName = itemEncontrado.nome_equipamento || itemEncontrado.cod_equipamento;
        EventBus.$emit('show-alert', {
          mensagem: this.$t('equipmentChecklist.equipmentSelected') || 
                   `${itemEncontrado.tipo === 'kit' ? 'Kit' : 'Equipamento'} "${itemName}" selecionado com sucesso!`,
          tipo: 'success'
        });
      } catch (error) {
        if (error instanceof SyntaxError) {
          // Not a JSON QR code, maybe it's just the code directly
          // Try to find by cod_equipamento or cod_kit directly
          let itemEncontrado = this.equipamentosFiltrados.find(
            e => e.cod_equipamento === decodedText
          );
          
          if (itemEncontrado) {
            // Add to equipment array if not already present
        if (!this.editedItem.id_equipamentos) {
          this.editedItem.id_equipamentos = [];
        }
        if (!this.editedItem.id_equipamentos.includes(itemEncontrado.id_equipamento)) {
          this.editedItem.id_equipamentos.push(itemEncontrado.id_equipamento);
        }
            this.stopQrScanner();
            const itemName = itemEncontrado.nome_equipamento || itemEncontrado.cod_equipamento;
            EventBus.$emit('show-alert', {
              mensagem: this.$t('equipmentChecklist.equipmentSelected') || 
                       `${itemEncontrado.tipo === 'kit' ? 'Kit' : 'Equipamento'} "${itemName}" selecionado com sucesso!`,
              tipo: 'success'
            });
            return;
          }
        }
        
        EventBus.$emit('show-alert', {
          mensagem: this.$t('equipmentChecklist.invalidQrCode') || 
                   'QR Code inválido. Por favor, escaneie o QR Code do equipamento ou kit.',
          tipo: 'error'
        });
      }
    },
    onInit(promise) {
      promise
        .then(() => {
          this.scanning = false;
          this.qrScannerError = null;
        })
        .catch((error) => {
          this.scanning = false;
          let errorMessage = 'Erro ao inicializar scanner de QR Code';
          
          const errorMsg = error && error.message ? error.message : (error ? String(error) : 'Erro desconhecido');
          const errorMsgLower = errorMsg.toLowerCase();
          
          if (errorMsgLower.includes('permission denied') || errorMsgLower.includes('permission') || errorMsgLower.includes('notallowederror')) {
            errorMessage = 'Permissão de câmera negada. Por favor, permita o acesso à câmera nas configurações do navegador.';
          } else if (errorMsgLower.includes('no cameras found') || errorMsgLower.includes('nenhuma câmera') || errorMsgLower.includes('notfounderror')) {
            errorMessage = 'Nenhuma câmera encontrada. Verifique se há uma câmera disponível.';
          } else if (errorMsgLower.includes('notreadableerror') || errorMsgLower.includes('trackstarterror')) {
            errorMessage = 'Erro ao acessar a câmera. Verifique se outra aplicação não está usando a câmera.';
          } else if (errorMsg) {
            errorMessage = errorMsg;
          }
          
          this.qrScannerError = errorMessage;
          EventBus.$emit('show-alert', {
            mensagem: errorMessage,
            tipo: 'error'
          });
        });
    },
    stopQrScanner() {
      this.qrScannerDialog = false;
      this.scanning = false;
      this.qrScannerError = null;
    },
    closeQrScanner() {
      this.stopQrScanner();
    }
  },
};
</script>

<style scoped>
.qr-scanner {
  width: 100%;
  min-height: 400px;
}

@media (max-width: 600px) {
  .qr-scanner {
    min-height: 300px;
  }
}
</style>

